import React from 'react';
import Obfuscate from 'react-obfuscate'
import animations from './animations';

class Footer extends React.Component {

	componentDidMount() {
		animations.animatePointer(this.animatedPointer);
	}

	handleSwitch() {
		let lightSwitch = document.getElementById('switch');

		if (lightSwitch.checked) {
			animations.animateLightsOn();
			this.props.handleChangeFavIcon(true);
		} else {
			animations.animateLightsOff();
			this.props.handleChangeFavIcon(false);
		}

		this.props.handleChangeLights();
	}

	render() {
		return (
			<footer className={this.props.className ? this.props.className : ''}>
				<div className="animated-pointer" ref={el => this.animatedPointer = el}>
					<div>Click<br />here</div>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96.88 82.52">
						<g id="Layer_2" data-name="Layer 2">
							<g id="Layer_1-2" data-name="Layer 1">
								<polygon className="pointer-bg" points="11.82 24.43 36.37 3.42 42.23 3.42 46.75 9.53 37.47 21.74 37.59 24.43 89.75 24.43 93.78 29.44 90.61 37.62 55.79 38.6 63.85 41.26 65.32 47.39 60.56 52.16 58.6 52.16 50.17 52.16 58.36 53.38 60.8 57.9 59.7 63.88 55.43 66.2 50.05 66.2 55.43 69.5 57.14 72.68 55.55 76.34 52.8 80.01 23.42 79.4 10.72 75.24 1.79 58.88 4.12 30.41 11.82 24.43"/>
								<path d="M50.12,82.52a9.31,9.31,0,0,0,9.27-9.27A9.56,9.56,0,0,0,57.76,68a9.11,9.11,0,0,0,5.81-8.56,9.53,9.53,0,0,0-1.63-5.29,9.33,9.33,0,0,0,4.58-13.25H87.61a8.84,8.84,0,0,0,6.52-2.75,9.26,9.26,0,0,0,2.75-6.52h0a9.31,9.31,0,0,0-9.27-9.27H40l6.41-6.42A9.38,9.38,0,0,0,47.57,4.08a9,9,0,0,0-6.41-4,9.53,9.53,0,0,0-7.34,2l-22.92,19A29.87,29.87,0,0,0,0,44.21V56A26.43,26.43,0,0,0,26.49,82.52Zm-39-11A21.77,21.77,0,0,1,4.69,56V44.21a25.6,25.6,0,0,1,9.16-19.56l23-18.94a4.69,4.69,0,0,1,3.66-1,4.62,4.62,0,0,1,3.26,2,5,5,0,0,1,.82,2.64,4.8,4.8,0,0,1-1.43,3.37l-7.54,7.64a3.92,3.92,0,0,0-.81,4.27,4,4,0,0,0,3.67,2.45h49.1a4.5,4.5,0,0,1,4.68,4.48h0A4.68,4.68,0,0,1,91,34.84a4.46,4.46,0,0,1-3.26,1.33H53.89a2.34,2.34,0,1,0,0,4.68h4.58a4.59,4.59,0,0,1,4.59,4.69,4.65,4.65,0,0,1-4.59,4.68H49.71a2.35,2.35,0,0,0,0,4.69H54.3a4.59,4.59,0,0,1,4.58,4.69,4.65,4.65,0,0,1-4.58,4.68H45.43a2.35,2.35,0,0,0,0,4.69H50a4.59,4.59,0,0,1,0,9.17H26.59A22.89,22.89,0,0,1,11.1,71.52Z"/>
							</g>
						</g>
					</svg>
				</div>

				<div className="footer-inner">
					<label className="switch do-animate-link">
						<input type="checkbox" value="1" id="switch" onChange={this.handleSwitch.bind(this)} />
						<span className="slider round" />
					</label>
					<a href="https://www.instagram.com/thekiwinomad_/" className="icon do-animate-icon" target="_blank" rel="noopener noreferrer">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><title>Social - Instagram</title><path d="M26.72.84A25.94,25.94,0,0,0,.84,26.72V73.28A25.94,25.94,0,0,0,26.72,99.16H73.28A25.94,25.94,0,0,0,99.16,73.28V26.72A25.94,25.94,0,0,0,73.28.84Zm0,10.35H73.28A15.38,15.38,0,0,1,88.81,26.72V73.28A15.38,15.38,0,0,1,73.28,88.81H26.72A15.38,15.38,0,0,1,11.19,73.28V26.72A15.38,15.38,0,0,1,26.72,11.19ZM75.87,19a5.18,5.18,0,1,0,5.18,5.18A5.17,5.17,0,0,0,75.87,19ZM50,25.42A24.58,24.58,0,1,0,74.58,50,24.66,24.66,0,0,0,50,25.42Zm0,10.35A14.23,14.23,0,1,1,35.77,50,14.15,14.15,0,0,1,50,35.77Z"/></svg>
					</a>
					<a href="http://www.linkedin.com/in/jwarner2" className="icon do-animate-icon" target="_blank" rel="noopener noreferrer">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><title>Social - Linkedin</title><path d="M23,33.59V97.21H1.89V33.59Zm1.35-19.78a10,10,0,0,1-3.15,7.87,12.65,12.65,0,0,1-8.77,3.14h0A11.78,11.78,0,0,1,3.9,21.68,10.12,10.12,0,0,1,.77,13.81,10.08,10.08,0,0,1,3.91,5.94a12.68,12.68,0,0,1,8.77-3.15,12.11,12.11,0,0,1,8.54,3.15A10.87,10.87,0,0,1,24.37,13.81ZM99.23,60.57V97.21H78.1V63c0-4.49-.68-7.87-2.47-10.57a9.45,9.45,0,0,0-8.09-3.84,11,11,0,0,0-6.77,2.27,13,13,0,0,0-4.27,5.63,15.33,15.33,0,0,0-.68,5.17V97.21H34.71c.23-17.08.23-31,.23-41.58V36.52l-.23-2.93H55.85v9.24h0a24.43,24.43,0,0,1,2.47-3.6,19.6,19.6,0,0,1,3.84-3.37,17.63,17.63,0,0,1,5.39-2.92A25.73,25.73,0,0,1,75,32c7.42,0,13.27,2.47,17.77,7.19C97.21,44.16,99.23,51.35,99.23,60.57Z"/></svg>
					</a>
					<Obfuscate
						email="me@josh.kiwi"
						headers={{
							subject: 'Josh! Lets connect.'
						}}
						className="do-animate-link"
					/>
				</div>
			</footer>
		);	
	}

};

export default Footer;


// WEBPACK FOOTER //
// ./src/js/components/Footer/Footer.js